import React from "react";

import TemplateIndex from "../../components/TemplateIndex";
import { ICardMenu } from "../../components/CardMenu";


const Apoio: React.FC = () => {
    const items: ICardMenu[] = [
        {
            path: "/material",
            icon: "book",
            text: "Material de apoio",
            roles: ["Admin", "Operador"],
            show: true
        },
        {
            path: "/videos",
            icon: "youtube play",
            text: "Vídeos",
            roles: ["Admin", "Operador"],
            show: true
        },
    ];

    return <TemplateIndex title="Apoio" cards={items} />;
}

export default Apoio;
